import { render, staticRenderFns } from "./CommissionsSummary.vue?vue&type=template&id=fa485434&scoped=true"
import script from "./CommissionsSummary.vue?vue&type=script&lang=js"
export * from "./CommissionsSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa485434",
  null
  
)

export default component.exports